import {useMemo} from 'react'
import {
  Flex, Text, Card, TextButton
} from '@binance/uikit'
import useApiKeyData from 'hooks/useApiKeyData'
import useFetchApiKey from 'hooks/useFetchApiKey'
import useUserLoginStatus from 'hooks/useUserLoginStatus'
import {API_DOC} from 'constants'

export default function APIKeyPane ({i18n}) {
  useFetchApiKey()
  const {apiKey} = useApiKeyData()
  const isLogin = useUserLoginStatus()

  return useMemo(
    () =>
      isLogin ? (
        <Card m="auto">
          <Flex mb={10}>
            <Text.Base width={80} fontSize="2" color="#848e9c">
              {i18n['tradeHistory-APIKeyLabel'] || 'API Key'}
            </Text.Base>
            <Text.Base fontSize="2" color="#fff">
              {apiKey?.key || ''}
            </Text.Base>
          </Flex>
          <Flex mb={10}>
            <Text.Base width={80} fontSize="2" color="#848e9c">
              {i18n['tradeHistory-APISecretLabel'] || 'API Secret'}
            </Text.Base>
            <Text.Base fontSize="2" color="#fff">
              {apiKey?.secretKey || ''}
            </Text.Base>
          </Flex>
          <Flex>
            <Text.Base width={80} color="#848e9c">
              {i18n['tradeHistory-APIDocsLabel'] || 'API Docs'}
            </Text.Base>
            <Text.Base fontSize="2" color="#fff">
              <TextButton onClick={() => (window.location.href = API_DOC)}>{API_DOC}</TextButton>
            </Text.Base>
          </Flex>
        </Card>
      ) : null,
    [apiKey, isLogin, i18n]
  )
}
